// Annuva Theme Interactivity & Mobile UX Engine
document.addEventListener('DOMContentLoaded', () => {
  initCartDrawer();
  initMobileMenu();
  initQuickSizes();
  initFreeShippingBar();
  initHeroSlider();
  initSliderDrag();
});

// Re-initialize dynamic components on Shopify Theme Customizer updates
document.addEventListener('shopify:section:load', () => {
  initSliderDrag();
  initQuickSizes();
  initHeroSlider();
});

// Global Add to Cart function for size chips & buttons
window.annuvaAddToCart = async function(variantId) {
  if (!variantId) return;
  try {
    const res = await fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: variantId, quantity: 1 })
    });
    if (res.ok) {
      if (window.annuvaOpenCart) {
        window.annuvaOpenCart();
      }
    } else {
      console.warn('Direct add returned status:', res.status);
      window.location.href = '/cart';
    }
  } catch (err) {
    console.error('Failed to add to bag:', err);
    window.location.href = '/cart';
  }
};

// Demo quick-add feedback when store has preview dummy items
window.annuvaQuickAddDemo = function(title, size) {
  if (window.annuvaOpenCart) {
    window.annuvaOpenCart();
  }
};

// Cart Drawer Management
function initCartDrawer() {
  const drawer = document.getElementById('annuva-cart-drawer');
  const backdrop = document.getElementById('annuva-cart-backdrop');
  const openButtons = document.querySelectorAll('[data-action="open-cart"]');
  const closeButtons = document.querySelectorAll('[data-action="close-cart"]');

  function openCart() {
    if (drawer) {
      drawer.classList.add('is-open');
      document.body.style.overflow = 'hidden';
      refreshCart();
    }
  }

  function closeCart() {
    if (drawer) {
      drawer.classList.remove('is-open');
      document.body.style.overflow = '';
    }
  }

  openButtons.forEach(btn => btn.addEventListener('click', (e) => {
    e.preventDefault();
    openCart();
  }));

  closeButtons.forEach(btn => btn.addEventListener('click', (e) => {
    e.preventDefault();
    closeCart();
  }));

  if (backdrop) {
    backdrop.addEventListener('click', closeCart);
  }

  const overlay = drawer ? drawer.querySelector('.annuva-cart-overlay') : null;
  if (overlay) {
    overlay.addEventListener('click', closeCart);
  }

  window.annuvaOpenCart = openCart;
  window.annuvaCloseCart = closeCart;
}

// Mobile Navigation Drawer
function initMobileMenu() {
  const toggle = document.querySelector('.annuva-hamburger');
  const mobileNav = document.getElementById('annuva-mobile-nav');
  const backdrop = document.getElementById('annuva-mobile-nav-backdrop');

  function openMenu() {
    if (mobileNav) {
      mobileNav.classList.add('is-open');
      if (backdrop) backdrop.classList.add('is-open');
      document.body.style.overflow = 'hidden';
    }
  }

  function closeMenu() {
    if (mobileNav) {
      mobileNav.classList.remove('is-open');
      if (backdrop) backdrop.classList.remove('is-open');
      document.body.style.overflow = '';
    }
  }

  if (toggle) {
    toggle.addEventListener('click', (e) => {
      e.preventDefault();
      if (mobileNav && mobileNav.classList.contains('is-open')) {
        closeMenu();
      } else {
        openMenu();
      }
    });
  }

  if (backdrop) {
    backdrop.addEventListener('click', closeMenu);
  }
}

// Hero Slideshow Touch & Autoplay
function initHeroSlider() {
  const track = document.querySelector('.annuva-hero__slider-track');
  const dots = document.querySelectorAll('.annuva-dot');
  if (!track || dots.length === 0) return;

  dots.forEach(dot => {
    dot.addEventListener('click', () => {
      const idx = parseInt(dot.getAttribute('data-index') || '0', 10);
      const slideWidth = track.clientWidth;
      track.scrollTo({ left: idx * slideWidth, behavior: 'smooth' });
    });
  });

  track.addEventListener('scroll', () => {
    const idx = Math.round(track.scrollLeft / track.clientWidth);
    dots.forEach((d, i) => {
      if (i === idx) d.classList.add('is-active');
      else d.classList.remove('is-active');
    });
  }, { passive: true });
}

// Quick Size Selection & Instant Add to Cart
function initQuickSizes() {
  document.querySelectorAll('.annuva-size-chip').forEach(chip => {
    chip.addEventListener('click', async (e) => {
      e.preventDefault();
      const variantId = chip.getAttribute('data-variant-id');
      if (!variantId) return;
      window.annuvaAddToCart(variantId);
    });
  });
}

// Free Shipping Bar Progress Meter
function initFreeShippingBar() {
  window.updateShippingMeter = function(cartSubtotal) {
    const meter = document.querySelector('.annuva-free-shipping-bar');
    if (!meter) return;

    const threshold = parseInt(meter.getAttribute('data-threshold') || '999', 10) * 100;
    const fill = meter.querySelector('.annuva-progress-fill');
    const msg = meter.querySelector('.annuva-progress-msg');

    if (!fill || !msg) return;

    if (cartSubtotal >= threshold) {
      fill.style.width = '100%';
      fill.style.backgroundColor = '#15803d';
      msg.innerHTML = '🎉 <strong>Congratulations!</strong> You have unlocked <strong>FREE SHIPPING!</strong>';
    } else {
      const remaining = ((threshold - cartSubtotal) / 100).toFixed(0);
      const percentage = Math.min(100, Math.max(0, (cartSubtotal / threshold) * 100));
      fill.style.width = `${percentage}%`;
      fill.style.backgroundColor = 'var(--annuva-primary)';
      msg.innerHTML = `Add <strong>₹${remaining}</strong> more to get <strong>FREE SHIPPING!</strong>`;
    }
  };
}

// Fetch and refresh cart contents via Shopify AJAX API
async function refreshCart() {
  try {
    const res = await fetch('/cart.js');
    const cart = await res.json();

    // Update cart counter badges
    document.querySelectorAll('.annuva-cart-badge').forEach(badge => {
      badge.textContent = cart.item_count;
    });

    // Update shipping meter
    if (window.updateShippingMeter) {
      window.updateShippingMeter(cart.total_price);
    }

    // Update drawer item list
    const itemsContainer = document.querySelector('.annuva-cart-body');
    const subtotalEl = document.querySelector('[data-cart-subtotal]');

    if (subtotalEl) {
      subtotalEl.textContent = `₹${(cart.total_price / 100).toLocaleString('en-IN')}`;
    }

    if (itemsContainer) {
      if (cart.items.length === 0) {
        itemsContainer.innerHTML = `
          <div style="text-align: center; padding: 48px 0; color: var(--annuva-text-subdued);">
            <svg width="48" height="48" fill="none" stroke="currentColor" stroke-width="1.5" viewBox="0 0 24 24" style="margin: 0 auto 16px; opacity: 0.4;">
              <path stroke-linecap="round" stroke-linejoin="round" d="M15.75 10.5V6a3.75 3.75 0 10-7.5 0v4.5m11.356-1.993l1.263 12c.07.665-.45 1.243-1.119 1.243H4.25a1.125 1.125 0 01-1.12-1.243l1.264-12A1.125 1.125 0 015.513 7.5h12.974c.576 0 1.059.435 1.119.993z" />
            </svg>
            <p style="font-size: 15px; margin: 0 0 18px; color: var(--annuva-text);">Your cart is currently empty</p>
            <a href="/collections/all" class="annuva-btn annuva-btn--primary" style="font-size: 12px; padding: 12px 24px;" onclick="if(window.annuvaCloseCart) window.annuvaCloseCart();">Explore Kurtis</a>
          </div>
        `;
        return;
      }

      itemsContainer.innerHTML = cart.items.map((item, idx) => `
        <div class="annuva-cart-item">
          <img class="annuva-cart-item__thumb" src="${item.featured_image ? item.featured_image.url : ''}" alt="${item.title}" width="80" height="100">
          <div class="annuva-cart-item__info">
            <h4 class="annuva-cart-item__title">${item.product_title}</h4>
            ${item.variant_title ? `<span class="annuva-cart-item__variant">Size: ${item.variant_title}</span>` : ''}
            <div class="annuva-cart-item__price">₹${(item.final_line_price / 100).toLocaleString('en-IN')}</div>
            <div class="annuva-cart-item__qty">
              <button onclick="changeCartQty(${idx + 1}, ${item.quantity - 1})">-</button>
              <span>${item.quantity}</span>
              <button onclick="changeCartQty(${idx + 1}, ${item.quantity + 1})">+</button>
            </div>
          </div>
          <button onclick="changeCartQty(${idx + 1}, 0)" style="background:none; border:none; cursor:pointer; color: #999; font-size: 20px; align-self: flex-start; padding: 4px;">&times;</button>
        </div>
      `).join('');
    }
  } catch (e) {
    console.error('Error refreshing cart:', e);
  }
}

window.changeCartQty = async function(line, quantity) {
  try {
    await fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ line, quantity })
    });
    refreshCart();
  } catch (err) {
    console.error(err);
  }
};

// Smooth Mouse Drag & Touch scroll support for sliders & preview
function initSliderDrag() {
  const tracks = document.querySelectorAll('.annuva-products-slider:not(.annuva-products-slider--grid), .annuva-categories-scroll-track:not(.annuva-categories-scroll-track--grid)');

  tracks.forEach(track => {
    let isDown = false;
    let startX = 0;
    let scrollLeft = 0;
    let moved = false;

    track.addEventListener('mousedown', (e) => {
      isDown = true;
      moved = false;
      track.classList.add('is-dragging');
      startX = e.pageX - track.offsetLeft;
      scrollLeft = track.scrollLeft;
    });

    track.addEventListener('mouseleave', () => {
      isDown = false;
      track.classList.remove('is-dragging');
    });

    track.addEventListener('mouseup', () => {
      isDown = false;
      track.classList.remove('is-dragging');
    });

    track.addEventListener('mousemove', (e) => {
      if (!isDown) return;
      e.preventDefault();
      const x = e.pageX - track.offsetLeft;
      const walk = (x - startX) * 1.5;
      if (Math.abs(x - startX) > 6) {
        moved = true;
      }
      track.scrollLeft = scrollLeft - walk;
    });

    // Prevent inadvertent link clicks when dragging with mouse
    track.querySelectorAll('a').forEach(link => {
      link.addEventListener('click', (e) => {
        if (moved) {
          e.preventDefault();
          e.stopPropagation();
        }
      });
    });
  });
}
